import { Component, OnInit } from '@angular/core';
import { DataStoreService } from 'src/app/data-store.service';
import { PlayerSkill } from 'src/app/models/models';

@Component({
  selector: 'app-player-skills',
  templateUrl: './player-skills.component.html',
  styleUrls: ['./player-skills.component.scss']
})
export class PlayerSkillsComponent implements OnInit {

  skills: PlayerSkill[] = [];

  constructor(public store: DataStoreService) { }

  ngOnInit(): void {
    this.skills = this.store.skills;
  }

}
